import { createUseStyles } from 'react-jss'

import { zIndex5 } from '../../../styles/const/common'

const useStyles = createUseStyles({
  tooltip: {
    // z index 5 is added to avoid cases when other elements e.g. Chart
    // are overlapping with tooltip and it can't be hovered
    zIndex: zIndex5
  },
  icon: {
    fontSize: 14,
    color: props => props?.color || '#000',
    display: 'flex'
  },
  tooltipBody: {
    fontSize: '12px',
    fontWeight: 400,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
    border: 'none !important',
    maxWidth: '400px'
  },
  structuredContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  description: {
    fontWeight: 500,
    marginBottom: '4px'
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  sectionTitle: {
    fontWeight: 600
  },
  sectionText: {
    lineHeight: '1.5',
    opacity: 0.95
  }
})

export default useStyles
